"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Input = require("./Input.styles");
var _hooks = require("../../hooks");
var _OffsetBox = require("../../Layout/OffsetBox");
var _useOffsetBox = require("../../Layout/OffsetBox/useOffsetBox");
var _OffsetBoxDropCard = require("../partials/OffsetBoxDropCard");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _DropList = require("./partials/DropList");
var _Card = require("../Card");
var _Icon = require("../Icon");
var _Button = require("../Button");
var _Portal = require("../../Layout/Portal");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Input = exports.Input = /*#__PURE__*/_react.default.forwardRef((props, outerRef) => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    dir = direction,
    position = 'bottom',
    placeholder,
    maxLength,
    isWithClearButton,
    onClearButtonClick,
    isAttachedToWindow = isMobileView,
    isFullScreen = false,
    isOpenOnFocus = false,
    autoCompleteOptions = [],
    onAutoCompleteSelect
  } = props;
  const {
    min,
    max,
    step
  } = props;
  const {
    type = 'text',
    id,
    ariaLabel,
    value = '',
    onChange,
    width
  } = props;
  const {
    dropContentRef,
    handleAnchorFocus,
    handleAnchorKeyUp,
    isOpen,
    open,
    close
  } = (0, _useOffsetBox.useOffsetBox)(isOpenOnFocus);
  const [actualBoxPosition, setActualBoxPosition] = (0, _react.useState)(position);
  const [inputValue, setInputValue] = (0, _react.useState)(value);
  const getValueAsPercentage = (0, _react.useCallback)(val => (val - min) * 100 / (max - min), [max, min]);
  const inputValueAsPercentage = type === 'range' ? getValueAsPercentage(Number(inputValue)) : 0;
  const styles = (0, _Input.useStyles)(props, isOpen, inputValueAsPercentage);
  const handleBoxPositionChange = pos => {
    setActualBoxPosition(pos);
  };
  const handleChange = event => {
    setInputValue(event.currentTarget.value);
    if (onChange) {
      onChange(event.currentTarget.value);
    }
  };
  const handleAutoCompleteSelect = option => {
    close();
    setInputValue(option.label);
    if (onAutoCompleteSelect) {
      onAutoCompleteSelect(option);
    }
  };
  const handleClearBtnClick = () => {
    if (onClearButtonClick) {
      onClearButtonClick();
    }
  };
  (0, _react.useEffect)(() => {
    if (autoCompleteOptions?.length) {
      open();
    } else {
      close();
    }
  }, [autoCompleteOptions, close, open]);
  (0, _react.useEffect)(() => {
    setInputValue(value);
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isAttachedToWindow && isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Input-mask']
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Input'],
      "data-testid": id,
      children: type === 'range' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        type: type,
        className: styles['cc-Input__field'],
        value: inputValue,
        onChange: handleChange,
        min: min,
        max: max,
        step: step,
        "aria-label": ariaLabel
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBox.OffsetBox, {
        isAttachedToWindow: isAttachedToWindow,
        position: position,
        isOpen: isOpen,
        anchorWidth: "auto",
        onBoxPositionChange: handleBoxPositionChange,
        anchor: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: styles['cc-Input__content'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            "data-testid": id ? `input-${id}` : null,
            type: type,
            className: styles['cc-Input__field'],
            placeholder: placeholder,
            maxLength: maxLength,
            dir: dir,
            value: inputValue,
            onChange: handleChange,
            onKeyUp: handleAnchorKeyUp,
            onFocus: handleAnchorFocus,
            "aria-label": ariaLabel,
            ref: outerRef
          }), isWithClearButton && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: styles['cc-Input__clear-btn'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
              id: "ccInputCloseButton",
              view: "link",
              color: "basic",
              onClick: handleClearBtnClick,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                name: "Close",
                width: 10,
                height: 10
              })
            })
          })]
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBoxDropCard.OffsetBoxDropCard, {
          ref: dropContentRef,
          position: actualBoxPosition,
          isAttachedToWindow: isAttachedToWindow,
          isFullScreen: isFullScreen,
          width: width,
          onClose: close,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.Card.Section, {
            size: "small",
            flexValues: {
              flexGrow: 1
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropList.DropList, {
              options: autoCompleteOptions,
              isFullScreen: isFullScreen,
              onInputOptionSelect: handleAutoCompleteSelect
            })
          })
        })
      })
    })]
  });
});